import {
  Typography as MuiTypography,
  type TypographyProps as MuiTypographyProps,
  type SxProps,
} from '@mui/material';
import { useThemeTokens } from '@providers/themeTokenProvider';
import { useTypographyTokens } from './typography.tokens';

export type TypographyVariantOptions =
  | 'displayLarge'
  | 'displayLargeVariant'
  | 'displayMedium'
  | 'displayMediumVariant'
  | 'displaySmall'
  | 'headingLarge'
  | 'headingMedium'
  | 'headingSmall'
  | 'headingXSmall'
  | 'headingOverline'
  | 'titleLarge'
  | 'titleMedium'
  | 'bodyLarge'
  | 'bodyMedium'
  | 'bodySmall'
  | 'labelLarge'
  | 'labelSmall'
  | 'button'
  | 'trimmedXSmall'
  | 'trimmedSmall'
  | 'trimmedNormal'
  | 'trimmedMedium'
  | 'trimmedLarge'
  | 'monospacedXlarge'
  | 'monospacedLarge'
  | 'monospacedSmall'
  | 'none';

export type TypographyPropsVariants = {
  variant?: TypographyVariantOptions;
};
export interface TypographyProps
  extends Omit<MuiTypographyProps, 'variant'>,
    TypographyPropsVariants {
  weight?: 'regular' | 'bold';
  sx?: SxProps;
  children?: React.ReactNode;
  colorVariant?: 'default' | 'variant';
  testId?: string;
}

export const Typography = ({
  variant = 'bodySmall',
  sx,
  children,
  weight = 'regular',
  colorVariant = 'default',
  testId,
  ...props
}: TypographyProps) => {
  const { sys, comp } = useThemeTokens(useTypographyTokens(weight));

  const color =
    props.color ||
    (colorVariant === 'default'
      ? comp.typography[variant]?.color || sys.color.onSurface
      : sys.color.onSurfaceVariant);

  return (
    <MuiTypography
      sx={[
        { ...comp.typography[variant], color },
        ...(Array.isArray(sx) ? sx : sx != null ? [sx] : []),
      ]}
      {...(testId && { 'data-testid': testId })}
      {...props}
    >
      {children}
    </MuiTypography>
  );
};
